module.exports = __webpack_public_path__ + "static/media/Messaing2.e86b2320.svg";